import React from "react";
import { Link } from "react-router-dom";
import NavItem from "./NavItem";

export default class SiteNav extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    const { isOpen } = this.state;
    return (
      <nav className="navbar sticky-top navbar-expand-sm navbar-dark bg-secondary">
        <Link className="navbar-brand" to="/">
          <img
            className="mr-2"
            src="/graphics/icons/icon-114x114.png"
            width="30"
            height="30"
            alt="White Power T logo in orange square"
          />{" "}
          REQUESTS
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          aria-expanded={isOpen ? true : false}
          aria-label="Toggle navigation"
          onClick={this.toggle}
        >
          <span className="navbar-toggler-icon" />
        </button>
        <div
          className={`${isOpen ? "" : "collapse"} navbar-collapse`}
          id="navbarNav"
        >
          <ul className="navbar-nav ml-3" style={{ width: "100%" }}>
            <NavItem to="/photo" title="Photos" active />
            <NavItem to="/video" title="Videos" />
            <NavItem to="/spirit" title="Spirit" />
            {/* <NavItem to="/facilities" title="Facility Projects" /> */}
          </ul>
          <ul className="navbar-nav justify-content-end">
            <li className="nav-item">
              <Link to="/help" className="nav-link">
                Help
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Shared/Nav/SiteNav.js